import * as React from 'react';
import type { SVGProps } from 'react';
const SvgNoChange = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={18}
    fill="none"
    {...props}
  >
    <path
      fill="var(--color-content-base-subdued)"
      fillRule="evenodd"
      d="M.9.9a.9.9 0 0 0 0 1.8h16.8a.9.9 0 1 0 0-1.8zm0 4.8a.9.9 0 0 0 0 1.8h5.185a6.9 6.9 0 0 0-.782 3H.9a.9.9 0 1 0 0 1.8h4.586a6.9 6.9 0 1 0 1.958-6.6zm15.8 5a.9.9 0 0 1-.9.9h-7a.9.9 0 0 1 0-1.8h7a.9.9 0 0 1 .9.9"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgNoChange;
